import React from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import LandingPage from 'components/pages/LandingPage';
import TariffPage from 'components/pages/TariffPage';
import DocumentsPage from 'components/pages/DocumentsPage';
import SpecialistsPage from 'components/pages/SpecialistsPage';
import WarrantyPage from 'components/pages/WarrantyPage';
import TariffComparisionPage from 'components/pages/TariffComparisionPage';
import Header from 'components/layout/Header';
import PureHeader from 'components/layout/PureHeader';
import Footer from 'components/layout/Footer';
import Analytics from 'contexts/Analytics';
import LandingURL from 'contexts/LandingURL';
import Tariff from 'contexts/Tariff';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <Header />
        <LandingPage />
        <Footer />
      </>
    ),
  },
  {
    path: '/tariff/:slug',
    element: (
      <>
        <PureHeader />
        <TariffPage />
      </>
    ),
  },
  {
    path: '/tariff-comparison',
    element: (
      <>
        <PureHeader />
        <TariffComparisionPage />
        <Footer />
      </>
    ),
  },
  {
    path: '/documents',
    element: (
      <>
        <PureHeader />
        <DocumentsPage />
      </>
    ),
  },
  {
    path: '/specialists',
    element: (
      <>
        <PureHeader />
        <SpecialistsPage />
        <Footer />
      </>
    ),
  },
  {
    path: '/warranty',
    element: (
      <>
        <PureHeader />
        <WarrantyPage />
        <Footer />
      </>
    ),
  },
]);

function App() {
  return (
    <LandingURL.Provider>
      <Analytics.Provider>
        <Tariff.Provider>
          <RouterProvider router={router}></RouterProvider>
        </Tariff.Provider>
      </Analytics.Provider>
    </LandingURL.Provider>
  );
}

export default App;
